export { default as throttle } from 'lodash.throttle';
export { default as debounce } from 'lodash.debounce';
import * as styledComponents from 'styled-components';
var _ref = styledComponents,
    styled = _ref["default"],
    css = _ref.css,
    createGlobalStyle = _ref.createGlobalStyle,
    keyframes = _ref.keyframes,
    ThemeProvider = _ref.ThemeProvider,
    withTheme = _ref.withTheme,
    ServerStyleSheet = _ref.ServerStyleSheet;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isNode = function isNode() {
  return !isBrowser();
};

var createBreakpoint = function createBreakpoint(functionKey) {
  return function (breakpointKey) {
    return function (strings) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return function (props) {
        var fn = props.theme.breakpoints[functionKey](breakpointKey);
        return css(["", "{", "}"], fn, css.apply(void 0, [strings].concat(args)));
      };
    };
  };
};

var breakpointUp = createBreakpoint('up');
var breakpoint = breakpointUp;
var breakpointDown = createBreakpoint('down');
var BASE_FONT_SIZE = 16;

var pxToRem = function pxToRem(size) {
  return size / BASE_FONT_SIZE;
};

var aspectRatio = css(["position:relative;padding-bottom:", ";"], function (_ref) {
  var aspectRatio = _ref.aspectRatio;
  return "".concat(1 / aspectRatio * 100, "%");
});
var fillAbsolute = css(["position:absolute;top:0;right:0;bottom:0;left:0;"]);
export { ServerStyleSheet, ThemeProvider, aspectRatio, breakpoint, breakpointDown, breakpointUp, createGlobalStyle, css, fillAbsolute, isBrowser, isNode, keyframes, pxToRem, styled, withTheme };